import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/how-it-works/#webpage",
   "url": "https://www.futurefamilyai.com/how-it-works/",
   "name": "How Pregnancy Monitoring Works | FutureFamilyAI",
   "description": "Four steps: connect a validated cuff and smartwatch, take two minutes a day, see a clear color status, and keep your care team informed.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "How It Works",
     "item": "https://www.futurefamilyai.com/how-it-works/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "How long does it take to set up FutureFamilyAI?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Most people finish setup in a few minutes: download the app, choose your stage, pair your cuff and smartwatch, and take your first reading. Your personalized baseline builds over the first 7–14 days."
     }
    },
    {
     "@type": "Question",
     "name": "How often should I take my blood pressure?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Follow your clinician's instructions. Many care plans ask for readings once or twice a day at consistent times. FutureFamilyAI sends reminders on the schedule you and your clinician choose."
     }
    },
    {
     "@type": "Question",
     "name": "What does each color status mean?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Green means steady; Yellow means a trend worth watching; Orange means your care team is reviewing; Red means contact your provider now. Each status comes with plain-language guidance."
     }
    },
    {
     "@type": "Question",
     "name": "Is FutureFamilyAI monitored 24/7?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Reviews happen during care-team hours and the app is not an emergency service. If you have severe symptoms or a very high reading, call your provider or 911 immediately."
     }
    },
    {
     "@type": "Question",
     "name": "What is PRV?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "PRV, or pulse-rate variability, is the beat-to-beat variation in pulse measured optically by your smartwatch. FutureFamilyAI shows it as a wellness trend, not a diagnostic measurement."
     }
    },
    {
     "@type": "Question",
     "name": "Can I use FutureFamilyAI without a smartwatch?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Blood pressure tracking works with your phone and a validated cuff. The smartwatch adds heart-rate, PRV, sleep and activity trends that make your status more informative."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  },
  {
   "@type": "MobileApplication",
   "name": "FutureFamilyAI",
   "operatingSystem": "iOS, Android",
   "applicationCategory": "HealthApplication",
   "offers": [
    {
     "@type": "Offer",
     "price": "0",
     "priceCurrency": "USD",
     "description": "Free pilot through December 31, 2026",
     "priceValidUntil": "2026-12-31"
    },
    {
     "@type": "Offer",
     "price": "39.99",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, monthly (after pilot)"
    },
    {
     "@type": "Offer",
     "price": "399",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, annual (after pilot)"
    }
   ],
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   }
  }
 ]
}`;

export default function HowItWorksPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">

          <div className="topvideo_section">
            <div className="ffh-wrap">
              <div className=" row">
                <div className=" col-md-6">
                  <nav className="ffh-crumbs" aria-label="Breadcrumb">
                    <Link to="/">Home</Link>
                    <span>›</span>
                    <span>How It Works</span>
                  </nav>
                  <h1>
                    Connected Pregnancy Care, Made Simple
                  </h1>

                  <p className="ffh-lead speakable-content">
                    FutureFamilyAI helps you track blood pressure and wellness trends, understand important changes, and stay connected with your healthcare provider throughout pregnancy, surrogacy, and postpartum recovery.
                  </p>
                  <p style={{ fontSize: "1.25rem", fontWeight: "700", color: "var(--blue-ink)" }}>
                    Simple Monitoring. Smarter Insights. Connected Care
                  </p>
                  <div class="ffh-cta-row">
                    <a class="ffh-btn ffh-primary" href="#">Download the App </a>
                    <a class="ffh-btn ffh-ghost" href="/contact-us?type=member" data-discover="true">Explore How It Works</a>
                  </div>

                </div>
                <div className="col-md-6" aria-label="Example FutureFamilyAI app screen (illustrative)">
                  <iframe width="100%" height="395" src="https://www.youtube.com/embed/xIkruCbrdyA" title="Pregnancy Support Between Doctor Visits | How FutureFamilyAI Helps Expecting Mothers" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </div>
          <div className="ffh-wrap">

            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                FutureFamilyAI works in four steps: choose your stage, connect a
                validated upper-arm cuff and smartwatch to your iPhone, take a
                two-minute daily check, and see one plain-language color status.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Expecting &amp; planning mothers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      The USPSTF recommends screening for hypertensive disorders
                      of pregnancy with blood pressure measurements throughout
                      pregnancy. (USPSTF, 2023)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Set up in minutes with devices you may own · Personal
                      baseline, not a generic average · People review every
                      Orange/Red status
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact-us/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">SIMPLE TO START</span>
            <h1>How Pregnancy Monitoring Works — Four Simple Steps</h1>
            <p className="ffh-answer speakable-content">
              FutureFamilyAI works in four steps: choose your stage, connect a
              validated upper-arm cuff and smartwatch to your iPhone, take a
              two-minute daily check, and see one plain-language color status. A
              7–14 day baseline personalizes your trends. Orange and Red
              patterns are reviewed by a care team guided by an ACOG/SMFM-based
              protocol. Join the free pilot to get set up in minutes.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                Request Free Pilot Access
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure className="ffh-photo">
                <img
                  src="/images/futurefamilyai-devices.jpg"
                  alt="iPhone, smartwatch and validated upper-arm blood pressure cuff used with FutureFamilyAI"
                  width="1200"
                  height="600"
                  loading="lazy"
                  style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                />
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    The USPSTF recommends screening for hypertensive disorders
                    of pregnancy with blood pressure measurements throughout
                    pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/hypertensive-disorders-pregnancy-screening">
                        USPSTF, 2023
                      </a>
                    </cite>
                  </li>
                  <li>
                    Validated upper-arm devices are recommended for
                    self-measured blood pressure; wrist and finger devices are
                    not recommended for routine use.
                    <cite>
                      Source:{" "}
                      <a href="https://www.ahajournals.org/doi/10.1161/CIR.0000000000000803">
                        AHA/AMA Joint Policy Statement, 2020
                      </a>
                    </cite>
                  </li>
                  <li>
                    Routine prenatal visits are commonly scheduled about every
                    four weeks until roughly 28 weeks of pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/womens-health/faqs/having-a-baby">
                        ACOG
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>What you need</h2>
                <ul>
                  <li>
                    An iPhone or Android phone (runs the app and syncs
                    securely).
                  </li>
                  <li>
                    A validated upper-arm blood pressure cuff — your
                    authoritative reading.
                  </li>
                  <li>
                    An Apple Watch (Series 9 or later, including Series 10 and
                    11) or Samsung Galaxy Watch for heart-rate, PRV, sleep and
                    activity trends.
                  </li>
                  <li>Five minutes to set up, then about two minutes a day.</li>
                </ul>
              </section>
              <section id="s2">
                <h2>What happens behind the color</h2>
                <p>
                  Your cuff readings, wearable trends and symptom answers are
                  compared with your own baseline and with the thresholds in
                  FutureFamilyAI&apos;s clinical protocol. The app then shows
                  one status — Green, Yellow, Orange or Red — with a sentence
                  telling you what to do next. You never have to interpret a
                  chart or a score on your own.
                </p>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
              <section id="s3">
                <h2>What the care team does — and doesn&apos;t do</h2>
                <p>
                  When your status reaches Orange or Red, a care-team member
                  reviews the pattern and follows the escalation steps agreed
                  with your clinician. The service runs during care-team hours
                  and is not monitored around the clock. Severe symptoms — a
                  severe headache, vision changes, chest pain or trouble
                  breathing — always mean calling your provider or 911 right
                  away.
                </p>
              </section>
              <section id="s4">
                <h2>You decide who sees what</h2>
                <p>
                  Sharing is off until you turn it on. You can invite your
                  physician, a partner, a surrogacy coordinator or intended
                  parents individually, choose whether they see readings, trends
                  or a summary, and revoke access in one tap.
                </p>
              </section>
              <section id="steps">
                <h2>How it works, step by step</h2>
                <ol className="ffh-steps">
                  <li>
                    <h3>Enroll</h3>
                    <p>
                      Create your account, choose your stage and agree to the
                      terms inside the app.
                    </p>
                  </li>
                  <li>
                    <h3>Daily monitoring</h3>
                    <p>
                      Cuff reading plus a quick symptom check; your watch works
                      in the background.
                    </p>
                  </li>
                  <li>
                    <h3>Status &amp; review</h3>
                    <p>
                      See Green, Yellow, Orange or Red. Orange and Red are
                      reviewed by people.
                    </p>
                  </li>
                  <li>
                    <h3>Lifelong wellness</h3>
                    <p>
                      Monitoring continues through postpartum and into long-term
                      heart health.
                    </p>
                  </li>
                </ol>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      How long does it take to set up FutureFamilyAI?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Most people finish setup in a few minutes: download the
                        app, choose your stage, pair your cuff and smartwatch,
                        and take your first reading. Your personalized baseline
                        builds over the first 7–14 days.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      How often should I take my blood pressure?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Follow your clinician&apos;s instructions. Many care
                        plans ask for readings once or twice a day at consistent
                        times. FutureFamilyAI sends reminders on the schedule
                        you and your clinician choose.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What does each color status mean?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Green means steady; Yellow means a trend worth watching;
                        Orange means your care team is reviewing; Red means
                        contact your provider now. Each status comes with
                        plain-language guidance.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is FutureFamilyAI monitored 24/7?</summary>
                    <div className="ffh-ans">
                      <p>
                        No. Reviews happen during care-team hours and the app is
                        not an emergency service. If you have severe symptoms or
                        a very high reading, call your provider or 911
                        immediately.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What is PRV?</summary>
                    <div className="ffh-ans">
                      <p>
                        PRV, or pulse-rate variability, is the beat-to-beat
                        variation in pulse measured optically by your
                        smartwatch. FutureFamilyAI shows it as a wellness trend,
                        not a diagnostic measurement.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Can I use FutureFamilyAI without a smartwatch?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Blood pressure tracking works with your phone and a
                        validated cuff. The smartwatch adds heart-rate, PRV,
                        sleep and activity trends that make your status more
                        informative.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/pregnancy-monitoring">Pregnancy Monitoring →</Link>
                  <Link to="/pricing">Pricing →</Link>
                  <Link to="/about">About &amp; Clinical Oversight →</Link>
                  <Link to="/privacy-safety">Privacy &amp; Safety →</Link>
                  <Link to="/faq">Frequently Asked Questions →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">What you need</a>
                  </li>
                  <li>
                    <a href="#s2">What happens behind the color</a>
                  </li>
                  <li>
                    <a href="#s3">
                      What the care team does — and doesn&apos;t do
                    </a>
                  </li>
                  <li>
                    <a href="#s4">You decide who sees what</a>
                  </li>
                  <li>
                    <a href="#steps">How it works, step by step</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}